import { config } from 'Shared/Services/environment.service';
import Head from 'next/head';
import { useState } from 'react';

interface IProps {
  title: string;
  description?: string;
  noIndex?: boolean;
}

function getIsNotIndex(noIndex: boolean): boolean {
  if (noIndex) return true;

  return config('NX_NEXT_PUBLIC_ENV') !== 'prd';
}

export const Meta: React.FC<IProps> = ({
  title,
  description,
  noIndex = false,
}) => {
  const [isNoIndex] = useState(getIsNotIndex(noIndex));

  return (
    <Head>
      <title>{title}</title>
      <meta name="title" content={title} />
      {description && <meta name="description" content={description} />}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, viewport-fit=cover"
      />
      {!!isNoIndex && <meta name="robots" content="noindex"></meta>}
    </Head>
  );
};
